import { CalendarDays, Wallet, Settings, Sparkles } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export default function BottomNav({ tab, setTab }) {
  const { t } = useI18n();
  const items = [
    { key: "today", label: t("navToday"), icon: Sparkles },
    { key: "calendar", label: t("navCalendar"), icon: CalendarDays },
    { key: "earnings", label: t("navEarnings"), icon: Wallet },
    { key: "settings", label: t("navSettings"), icon: Settings },
  ];

  return (
    <nav className="fixed bottom-0 inset-x-0 z-30 border-t border-white/10 bg-background/95 backdrop-blur">
      <div className="max-w-lg mx-auto grid grid-cols-4">
        {items.map(({ key, label, icon: Icon }) => {
          const active = tab === key;
          return (
            <button
              key={key}
              data-testid={`nav-${key}`}
              onClick={() => setTab(key)}
              className="flex flex-col items-center gap-1 py-3 transition-colors"
            >
              <Icon className={`h-5 w-5 ${active ? "text-primary" : "text-muted-foreground"}`} />
              <span className={`text-[11px] font-medium ${active ? "text-primary" : "text-muted-foreground"}`}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
